import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//工作量相关API

const courseAdjustAdultEducation = {
    courseAdjust: {
        queryList: config => createAPI('/courseAdjustAdultEducation/queryList', 'post', config),
        initOption: config => createAPI('/courseAdjustAdultEducation/initOption', 'post', config),
        teacherOption: config => createAPI('/courseAdjustAdultEducation/teacherOption', 'post', config),
        majorOption: config => createAPI('/courseAdjustAdultEducation/majorOption', 'post', config),
        classOption: config => createAPI('/courseAdjustAdultEducation/classOption', 'post', config),
        courseOption: config => createAPI('/courseAdjustAdultEducation/courseOption', 'post', config),
        skzcOption: config => createAPI('/courseAdjustAdultEducation/skzcOption', 'post', config),
        weekOption: config => createAPI('/courseAdjustAdultEducation/weekOption', 'post', config),
        jcOption: config => createAPI('/courseAdjustAdultEducation/jcOption', 'post', config),
        adjustReasonOption: config => createAPI('/courseAdjustAdultEducation/adjustReasonOption', 'post', config),
        siteOption: config => createAPI('/courseAdjustAdultEducation/siteOption', 'post', config),
        saveAdjust: config => createAPI('/courseAdjustAdultEducation/saveAdjust', 'post', config),
        checkApplyUsed: config => createAPI('/courseAdjustAdultEducation/checkApplyUsed', 'post', config),
        auditReject: config => createAPI('/courseAdjustAdultEducation/auditReject', 'post', config),
        queryAuditFlow: config => createAPI('/courseAdjustAdultEducation/queryAuditFlow', 'post', config),

        uploadMultiFile: config => createAPI('/courseAdjustAdultEducation/uploadMultiFile', 'post', config),
        attachmentList: config => createAPI('/courseAdjustAdultEducation/attachmentList', 'post', config),
        delFile: config => createAPI('/courseAdjustAdultEducation/delFile', 'post', config),
        updateAuditState: config => createAPI('/courseAdjustAdultEducation/updateAuditState', 'post', config),
        yjhskzcOption: config => createAPI('/courseAdjustAdultEducation/yjhskzcOption', 'post', config),
        yjhxqOption: config => createAPI('/courseAdjustAdultEducation/yjhxqOption', 'post', config),
        yjhsjxlOption: config => createAPI('/courseAdjustAdultEducation/yjhsjxlOption', 'post', config),
        teaAndSiteOption: config => createAPI('/courseAdjustAdultEducation/teaAndSiteOption', 'post', config),
        tzhskzcOption: config => createAPI('/courseAdjustAdultEducation/tzhskzcOption', 'post', config),
        tzhxqOption: config => createAPI('/courseAdjustAdultEducation/tzhxqOption', 'post', config),
        tzhsjxlOption: config => createAPI('/courseAdjustAdultEducation/tzhsjxlOption', 'post', config),
        checkEnableSite: config => createAPI('/courseAdjustAdultEducation/checkEnableSite', 'post', config),
        checkUnauditAdjust: config => createAPI('/courseAdjustAdultEducation/checkUnauditAdjust', 'post', config),

        queryList_monitor: config => createAPI('/courseAdjustAdultEducation/queryList_monitor', 'post', config),
        monitorConfirm: config => createAPI('/courseAdjustAdultEducation/monitorConfirm', 'post', config),
        queryclass: config => createAPI('/courseAdjustAdultEducation/queryclass', 'post', config),
        exportAdjustInfo: config => createAPI('/courseAdjustAdultEducation/exportAdjustInfo', 'post', config),
        queryBtkxx: config => createAPI('/courseAdjustAdultEducation/queryBtkxx', 'post', config),
    },
};


export default courseAdjustAdultEducation;



// WEBPACK FOOTER //
// ./src/api/modules/courseAdjustAdultEducation.js